// import LS from "./localStorage";
import _omit from "lodash/omit";
import { setTimeout } from "core-js";

let passphrase = "bsiTokenGenerator";
// let token = LS.getItem(token);
// let refresh = LS.getItem(refresh);
// let time = LS.getItem(time);
let env;

async function fetchApi(routes, config = {}) {
    // eslint-disable-next-line
    const url = config.external_url || process.env.VUE_APP_SERVER; // default url api gateway
    config.headers = {
      ...(config?.headers || {
        // eslint-disable-next-line
        "x-api-key": process.env.VUE_APP_API_KEY_DEV,
        "Content-Type": "application/json",
      }),
    };
    if (window.token || localStorage.getItem("token"))
      config.headers.Authorization =
        window.token || localStorage.getItem("token");
    const responseJSON = await fetch(`${url}${routes}`, config),
      response = await responseJSON.json();
  
    if (responseJSON.status >= 400)
      throw (responseJSON.status == 400 && !response.message) ||
        responseJSON.status == 401
        ? responseJSON.status
        : response.message;
    if (responseJSON.status == 403 && response.message == 'User is not authorized to access this resource with an explicit deny' ) refreshToken(); 
    return response;
}

async function requester(ctx) {
  const { headers = {}, url, body } = ctx;
  if (!url) return Promise.reject(new Error("URL is required"));
  return await fetch(`${process.env.VUE_APP_SERVER}${url}`, {
    ..._omit(ctx, ["headers", "url", "body"]),
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      ...{
        "x-api-key": process.env.VUE_APP_API_KEY_DEV,
        "Content-Type": "application/json"
      },
      ...headers
    },
    mode: "cors"
  })
    .then(response => {
      if (
        typeof response.status === "number" &&
        response.status >= 200 &&
        response.status < 400
      )
        return response;

      if(url == '/meet/meet-coorelation' && response.status == 410) return response;
      
      throw new Error(
        `Invalid request status ${response.status}. ${JSON.stringify(
          response.json()
        )}`
      );
    })
    .then(response => response.json());
}

// send refresh token request
function refreshToken() {
    let token = localStorage.getItem("userInfo");
    if (token) {
      token = JSON.parse(token);
      return fetchApi("/key/refresh", {
        method: "POST",
        body: JSON.stringify({
          refresh: token.refresh,
          passphrase: "stringOfPartnerDev",
        }),
      }).then((response) => {
        if (response.token) {
          token.token = response.token;
          window.token = response.token;
          localStorage.setItem("userInfo", JSON.stringify(token));
        }
      });
    }
}

/**
 *
 * @returns
 */
function getEnvironment(resolve) {
  
  fetchApi(`environment`, {
    method: "POST",
    body: JSON.stringify({
        url: location.origin,
    }),
  }).then(res => {
    env = res.env
    resolve(res);
  }).catch(err => {
    console.log("request environment FAIL")
    console.log(err)
    setTimeout(() => {
      getEnvironment(resolve);
    }, 5000);
  });
  
}

/**
 *
 * @returns
 */
 let countDataProcessing = 0;
 function sendDataProcessing(data, resolve) {
  countDataProcessing++;
  return getToken().then(key => {
    return fetchApi(`data_processing`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: key.token,
        "x-api-key": process.env.VUE_APP_API_KEY_DEV
      }
    }).then(res => {
      resolve(res);
    }).catch(err => {
      console.log("request post user FAIL")
      console.log(err)
      setTimeout(() => {
        if(countDataProcessing<6) resolve(null);
        sendDataProcessing(data, resolve);
      }, 5000);
    });
  });
}

let countDataPost = 0;
function setDataUsers(data, resolve) {
  countDataPost++;
  return getToken().then(key => {
    return fetchApi(`data_user`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: key.token,
        "x-api-key": process.env.VUE_APP_API_KEY_DEV
      }
    }).then(res => {
      resolve(res);
    }).catch(err => {
      console.log("request post user FAIL")
      console.log(err)
      setTimeout(() => {
        if(countDataPost<6) resolve(null);
        setDataUsers(data, resolve);
      }, 5000);
    });
  });
}


function fetchUsers(data, resolve) {
  return getToken().then(key => {
    return  fetchApi(`data_user?document=${data.document}`, {
      method: "GET",
      headers: {
        Authorization: key.token,
        "x-api-key": process.env.VUE_APP_API_KEY_DEV
      }
    }).then(res => {
      resolve(res);
    }).catch(err => {
      console.log("request get user FAIL")
      console.log(err)
      setTimeout(() => {
        fetchUsers(data, resolve);
      }, 5000);
      
    });
  });
}

function windowDispatchEvent(name, detail) {
  let event = new CustomEvent(name, { detail });
  window.dispatchEvent(event);
}

function getToken(manualKey, keysource, body = {}) {

  return recursiveRequest(
    {
      url: "key/token",
      body: {
        token: env.VUE_APP_BSI_KEY,
        authentication_engine: keysource || (manualKey ? "bsix" : "bsi"),
        passphrase,
        ...body
      },
      method: "POST"
    },
    () =>
      windowDispatchEvent("tokenError", {
        message: "Cant resolve token in BSIX"
      })
  )
    
}


function recursiveRequest(config, errorEventFunction) {
  return new Promise(resolve => {
    executor();
    // eslint-disable-next-line no-unused-vars
    async function executor() {
      let time = Date.now();
      try {
        const response = await requester(config);
        resolve(response);
      } catch (error) {
        console.error("Error in recursiveRequest", error);
        let newTime = Date.now() - time;
        if (typeof errorEventFunction === "function")
          errorEventFunction(newTime);
        if (newTime < 2000) setTimeout(() => executor(), 2000 - newTime);
        else executor();
      }
    }
  });
}

// function setValues({ tokenValue, refreshValue, timeValue }) {
//   if (tokenValue) {
//     token = tokenValue;
//     LS.setItem("token", tokenValue);
//   }
//   if (refreshValue) {
//     refresh = refreshValue;
//     LS.setItem("token", refreshValue);
//   }
//   if (timeValue) {
//     time = timeValue;
//     LS.setItem("time", timeValue);
//   }
// }

/**
 * 
 */
 function getAffiliate(params) {
  return fetchApi(`/verify-beneficiary/client/1`, {
      external_url: params.url, // url to external api
      method: "POST",
      body: params.data,
      headers: params.headers
  });
}

function externalRequest(params){
  
  return getToken().then(key => {

    return fetchApi(`mirror_request`, {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        Authorization: key.token,
        "x-api-key": process.env.VUE_APP_API_KEY_DEV
      }
    }).catch(error=> {
      console.log(error)
      if(error=="User is not authorized to access this resource with an explicit deny") {
        localStorage.removeItem('token');
        this.externalRequest();
      } 
    } );
  });
}

// Export
export {
    fetchApi,
    getEnvironment,
    getAffiliate,
    externalRequest,
    sendDataProcessing,
    setDataUsers,
    fetchUsers
}